import { render, staticRenderFns } from "./RecordingsTable.vue?vue&type=template&id=67087b36&scoped=true&"
import script from "./RecordingsTable.vue?vue&type=script&lang=js&"
export * from "./RecordingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67087b36",
  null
  
)

export default component.exports